window.CustomAccordion ||= class extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.name = this.details.dataset.name;
    this.others = [...document.querySelectorAll(`details[data-name=${this.name}]`)]
      .map((d) => d.closest(this.nodeName.toLowerCase()))
      .filter((e) => e != this);

    this.alreadyOpen = this.details.open;

    this.summary = this.details.querySelector("summary");
    this.summary.addEventListener("click", this.onSummaryClick.bind(this));
  }

  onSummaryClick(ev) {
    ev.preventDefault();

    this.toggle();
  }

  open(closeOthers = false) {
    this.details.setAttribute("open", "open");
    if (closeOthers) {
      this.closeOthers();
    }
  }

  close() {
    this.details.removeAttribute("open");
  }

  closeOthers() {
    this.others.forEach(other => other.close());
  }

  toggle() {
    (this.details.open)
      ? this.close()
      : this.open(true);
  }
}

window.MobileAccordion ||= class extends CustomAccordion {
  constructor() {
    super();

    window.breakpoints.desktop.addEventListener(
      "change",
      this.onMediaQueryChange.bind(this)
    );
    this.onMediaQueryChange(window.breakpoints.desktop);
    this.querySelector('.active')?.addEventListener('click', this.onActiveLinkClicked.bind(this));
  }

  onMediaQueryChange(query) {
    if (query.matches) {
      this.open();
    } else {
      if (this.alreadyOpen) {
        this.alreadyOpen = false;
        return
      }

      this.close();
    }
  }

  onSummaryClick(ev) {
    ev.preventDefault();
    if (window.breakpoints.desktop.matches) return;

    this.toggle();
  }

  onActiveLinkClicked(ev) {
    ev.preventDefault();
    this.close();
  }
}

if (customElements.get("custom-accordion") === undefined) {
  customElements.define("custom-accordion", CustomAccordion);
  customElements.define("mobile-accordion", MobileAccordion);
}
